module.exports = __webpack_public_path__ + "img/19.2f07e3ca.jpg";